<script>
  import dayjs from 'dayjs';
  import {
    FLATPICKR_OPTIONS,
    FP_DATE_FORMAT,
    FP_NO_YEAR_DATE_FORMAT,
  } from '../../../../components/availability/availability-datepicker-config';
  import {
    getParamsValues,
    isCheckInAndCheckOutDateIsValid,
  } from '../../../../components/availability/availability-utilities';
  import {
    availabilityWindowWidth,
    dateFrom,
    datesValue,
    dateTo,
    isDateParametersValid,
    guestsQuery,
    scContextItemIdQuery,
    scFormTokenQuery,
  } from '../store/store.js';
  import { Flatpickr } from './../action/flatpickr.js';
  import {
    availabilityLocationTypes,
    availabilityData,
    fetchStates,
    isFetchingAvailability,
  } from './../store/fetchAvailabilityData.js';
  import { availabilityEnableDatesForCalendar,
    getAvailabilityEnableDates,
    lastCheckoutDatesForCalendar,
    maxDaysInAdvance } from './../store/fetchAvailabilityEnableDates.js';
  
  import ClearButton from './ClearButton.svelte';
  // Request query string
  $: endPointQueryString = `${$scContextItemIdQuery}${$guestsQuery}&${$scFormTokenQuery}`;

  // Search url params
  const { isHasParamsDates, paramDateFrom, paramDateTo } = getParamsValues(
    window.location.search
  );

  /**
   * onReady hook for Flatpickr
   * @author Dat Doan
   * @date 2021-06-05
   * @param {Date} dateOjb
   * @param {String} dateStr - a string representation of the latest selected Date object by the user. The string is formatted as per the dateFormat option
   * @param {flatpickr} instance - the flatpickr object, containing various methods and properties
   */
  const onReady = (dateOjb, dateStr, instance) => {
    if (
      isHasParamsDates &&
      isCheckInAndCheckOutDateIsValid(paramDateFrom, paramDateTo)
    ) {
      instance.setDate($datesValue);
      dateFrom.set(dayjs(paramDateFrom));
      dateTo.set(dayjs(paramDateTo));
    }else{
      if (typeof $availabilityEnableDatesForCalendar === 'undefined') {
      	getAvailabilityEnableDates(endPointQueryString);
      }
    }

    
  };

  /**
   * onDayCreate hook for Flatpickr
   * @author Dat Doan
   * @date 2021-08-20
   * @param {Array} selectedDates - an array of Date objects selected by the user. When there are no dates selected, the array is empty.
   * @param {String} dateStr - a string representation of the latest selected Date object by the user. The string is formatted as per the dateFormat option
   * @param {flatpickr} instance - the flatpickr object, containing various methods and properties
   * @param {HTMLElement} dayElem - every date cell element
   */
  const onDayCreate = (selectedDates, dateStr, instance, dayElem) => {
    if (typeof $availabilityEnableDatesForCalendar !== 'undefined') {
      const isUnavailableDate = !$availabilityEnableDatesForCalendar.includes(dayjs(dayElem.dateObj).format('DD/MM/YYYY'));
      const isLastCheckoutDate = $lastCheckoutDatesForCalendar.includes(dayjs(dayElem.dateObj).format('DD/MM/YYYY'));
      const isDisabledDate = dayElem.classList.contains('flatpickr-disabled');
      const noDateSelected = selectedDates.length === 0;
      const dateSelectionStarted = selectedDates.length === 1;
      const datesSelected = selectedDates.length === 2;
      var maxStayDays = $lastCheckoutDatesForCalendar.length;
      console.log("maxStayDays=" + maxStayDays);
      maxStayDays=50;
      console.log("maxStayDays=" + maxStayDays);
      const lastDay = dayjs().add($maxDaysInAdvance, 'day');
         
      if(noDateSelected || datesSelected){
        if(isLastCheckoutDate){
          dayElem.classList.add('flatpickr-disabled');
          dayElem.classList.add('lastcheckoutdate-flatpickr-disabled');
        }
        else if (isDisabledDate) {
          //dayElem.classList.add('text-blue');        
        }
        else if (isUnavailableDate) {
          //dayElem.classList.add('text-line-through');
          dayElem.classList.add('flatpickr-disabled');
          dayElem.classList.add('unavailabledate-flatpickr-disabled');
        }            
        if (isUnavailableDate &&  dayjs(dayElem.dateObj) > lastDay) {
          dayElem.classList.add('date-unavailable');        
        }
      }
      else 
      {  
        let offset=-1;
          const startDate = dayjs(selectedDates[0])   
          const calDate = dayjs(dayElem.dateObj)
          offset = calDate.diff(startDate, 'day');
        
        if(offset < 0){
            if(!dayElem.classList.contains("flatpickr-disabled")){
              dayElem.classList.add("flatpickr-day-tempdisabled");
            }
          }
          if(offset == 0){        
          }
          if(dateSelectionStarted && offset > 0 && offset <= maxStayDays){
            dayElem.classList.add("text-gray-dark");
          
          }
          if(dateSelectionStarted && offset > maxStayDays){
            if(!dayElem.classList.contains("flatpickr-disabled")){
              dayElem.classList.add("flatpickr-disabled");
            }
            dayElem.classList.add("flatpickr-day-tempdisabled");
          }
          if (isUnavailableDate &&  dayjs(dayElem.dateObj) > lastDay) {
            dayElem.classList.add('date-unavailable');        
          }
      }
    }
  };

  /**
   * onOpen hook for Flatpickr
   * @author Dat Doan
   * @date 2021-08-20
   * @param {Array} selectedDates - an array of Date objects selected by the user. When there are no dates selected, the array is empty.
   * @param {String} dateStr - a string representation of the latest selected Date object by the user. The string is formatted as per the dateFormat option
   * @param {flatpickr} instance - the flatpickr object, containing various methods and properties
   */
  const onOpen = (selectedDates, dateStr, instance) => {

    //console.log ("onOpen " + selectedDates.length + " " + dateStr + " " + instance.input.value);
    // Show two calendar on large screen
    isLargeScreen
      ? instance.set('showMonths', 2)
      : instance.set('showMonths', 1);

    const dateSelectionStarted = selectedDates.length === 1;    
    const datesSelected = selectedDates.length === 2;

    if(dateSelectionStarted){
      instance.input.value = dateStr;
      instance.jumpToDate(selectedDates[0], false); 
      return;
    }
    // Bail early when both dates are not selected
    if (!datesSelected) return;

    const [selectedDateFrom, _dateTo] = selectedDates;
    // Retain the date string
    instance.input.value = dateStr;
    // When datepicker open show the selectedDateFrom
    instance.jumpToDate(selectedDateFrom, false);
  };

  /**
   * onChange hook for Flatpickr
   * @author Dat Doan
   * @date 2021-06-05
   * @param {Array} selectedDates - an array of Date objects selected by the user. When there are no dates selected, the array is empty.
   * @param {String} dateStr - a string representation of the latest selected Date object by the user. The string is formatted as per the dateFormat option
   * @param {flatpickr} instance - the flatpickr object, containing various methods and properties
   */
  const onChange = (selectedDates, dateStr, instance) => {
    //console.log ("onChange");
    if (typeof $availabilityEnableDatesForCalendar === 'undefined') return;
    const noDateSelected = selectedDates.length === 0;
    const dateSelectionStarted = selectedDates.length === 1;
    const datesSelected = selectedDates.length === 2;

    if (noDateSelected) {
      dateFrom.set('');
      dateTo.set('');
    }
    
    const maxStayDays = $lastCheckoutDatesForCalendar.length;

    if (dateSelectionStarted){
      dateFrom.set(dayjs(selectedDates[0]));
      dateTo.set('');
    }

    // Bail when both dates is not selected
    if (!datesSelected) return;

    let [firstSelectedDate, secondSelectedDate] = selectedDates;

    const isDatesFromFutureYear =
      dayjs().isBefore(firstSelectedDate, 'year') ||
      dayjs().isBefore(secondSelectedDate, 'year');

    if (isDatesFromFutureYear) {
      // Display year on future year selection
      instance.set('dateFormat', FP_DATE_FORMAT);
    } else {
      // Hide year on current year selection
      instance.set('dateFormat', FP_NO_YEAR_DATE_FORMAT);
    }

    const isSameDatesSelected = dayjs(firstSelectedDate).isSame(
      dayjs(secondSelectedDate)
    );
    if (isSameDatesSelected) {
      secondSelectedDate = dayjs(firstSelectedDate).add(1, 'day');
    }

    

    dateFrom.set(dayjs(firstSelectedDate));
    dateTo.set(dayjs(secondSelectedDate));
  };

  // FlatPicker options
  let options = {
    ...FLATPICKR_OPTIONS,
    onReady,
    onDayCreate,
    onOpen,
    onChange,
  };

  $: isLargeScreen = $availabilityWindowWidth >= 768;

  // Check if URL parameter dates are valid
  $: paramDatesIsValid =
    isHasParamsDates &&
    isCheckInAndCheckOutDateIsValid(paramDateFrom, paramDateTo);
  // Binding dates to value
  $: isNotDatesSelected = $datesValue.length !== 2;
  $: if (paramDatesIsValid) {
    dateFrom.set(dayjs(paramDateFrom));
    dateTo.set(dayjs(paramDateTo));
    isDateParametersValid.set(true);
  }

  const clearDatepicker = () => {
    isFetchingAvailability.set(fetchStates.IDLE);
    availabilityLocationTypes.set([]);
    availabilityData.set({});
  };
</script>

<div use:Flatpickr={{ calendarConfig: options, value: $datesValue }}>
  <div
    class="availability-datepicker bg-white border rounded-1 border-gray-dark box-sizing-border cursor-pointer d-flex f4 flex-1 flex-items-center flex-justify-between helvetica-medium is-active lh-condensed outline-focus position-relative text-left width-full"
    id="availability-datepicker"
    data-testid="availability-datepicker">
    <svg
      class="left-0 top-0 m-2 position-absolute opacity-50 z-index-1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 23"
      width="20"
      height="20"
      aria-hidden="true"
      focusable="false"
      ><path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.75 0a.75.75 0 01.75.75V3h9V.75a.75.75 0 111.5 0V3h2.75c.966 0 1.75.784 1.75 1.75v16a1.75 1.75 0 01-1.75 1.75H2.25A1.75 1.75 0 01.5 20.75v-16C.5 3.784 1.284 3 2.25 3H5V.75A.75.75 0 015.75 0zM20 9.5H2v11.25c0 .138.112.25.25.25h17.5a.25.25 0 00.25-.25V9.5z"
        fill="#2B2B2B" /><path
        d="M18 13a1 1 0 11-2 0 1 1 0 012 0zM18 17a1 1 0 11-2 0 1 1 0 012 0zM12 13a1 1 0 11-2 0 1 1 0 012 0zM12 17a1 1 0 11-2 0 1 1 0 012 0zM6 13a1 1 0 11-2 0 1 1 0 012 0zM6 17a1 1 0 11-2 0 1 1 0 012 0z"
        fill="#2B2B2B" /></svg>
    <input
      type="text"
      class="bg-transparent border-0 cursor-pointer f4 helvetica-medium lh-condensed outline-focus p-2 pl-5 rounded-1 text-gray-dark width-full z-index-100"
      placeholder="Check in – Check out"
      data-testid="availability-datepicker-input"
      data-input
      data-toggle />
    <ClearButton
      label="dates"
      hidden={isNotDatesSelected}
      buttonId="dates-button"
      dataClear={true}
      on:click={clearDatepicker} />
  </div>
</div>

<!-- <style lang="stylus" global>
  @require "./../style/npws.styl"
</style> -->
<style global>  

  .flatpickr-day.flatpickr-day-tempdisabled,
  .flatpickr-day.flatpickr-day-tempdisabled.flatpickr-disabled,
  .flatpickr-day.flatpickr-disabled.unavailabledate-flatpickr-disabled.date-unavailable,
  .flatpickr-day.flatpickr-disabled.lastcheckoutdate-flatpickr-disabled.date-unavailable
  {
	  color: #929292;
	  text-decoration: none;
  }
  .flatpickr-day.flatpickr-disabled,
  .flatpickr-day.flatpickr-disabled.lastcheckoutdate-flatpickr-disabled
  {
    color: #929292 ;
    text-decoration: line-through;
  }
  
  .flatpickr-day.inRange.flatpickr-disabled{
    background-color: rgb(230, 230, 230);
    color: #393939 ;
    text-decoration: none;
  }
  .flatpickr-day.selected.endRange{
    background-color: #006881;
  }
  .flatpickr-day.flatpickr-disabled.lastcheckoutdate-flatpickr-disabled.date-unavailable,
  .flatpickr-day.flatpickr-disabled.unavailabledate-flatpickr-disabled.date-unavailable,
  .flatpickr-day.flatpickr-disabled.flatpickr-day-tempdisabled.date-unavailable
  {
    color: #cdcdcd;
  }
 </style>